import { QuotationSummaryResponse } from 'data-layer-cr/dist/models';

export const getSummaryTitle = (summary: QuotationSummaryResponse): string => {
  if (summary.parentQuotation === 0) {
    return `${summary.id} - ${summary.username}`;
  }
  const fill = summary.copyOrder > 9 ? '' : '0';

  return `${summary.parentQuotation}-${fill}${summary.copyOrder} - ${summary.username}`;
};

export const getRegularTitle = (summary: QuotationSummaryResponse): string => {
  return `${summary.id} - ${summary.username}`;
};

export default getSummaryTitle;
